module.exports = __webpack_public_path__ + "static/media/color-circles-dark.714ed12f.png";